export const generateFiltersFromData = (data, filterConfigs, t = null) => {
  return filterConfigs.map(config => {
    // Özel durum: jobs etiket filtresi için seçenekleri data'dan üretmiyoruz,
    // sistem etiketleri DataTableContainer içinde dolduruluyor.
    if (config.field === 'tags') {
      return {
        id: config.id || config.field,
        field: config.field,
        label: t ? t(config.label) : config.label,
        value: '',
        filterType: config.filterType || 'multiselect',
        options: [],
      };
    }

    // Config'den options geldiyse (bos array de dahil) direkt kullan — aksi
    // halde asagidaki uniqueValues akisi row degerlerinden options uretir ve
    // runtime-doldurulan filter'lar (ornegin dokuman etiketleri) icin yanlis
    // label uretebilir (`[object Object]` veya ham ID).
    if (Array.isArray(config.options)) {
      return {
        id: config.id || config.field,
        field: config.field,
        label: t ? t(config.label) : config.label,
        value: '',
        filterType: config.filterType || 'exact',
        options: config.options,
      };
    }

    // Dizi alanlarını düzleştir (reportTags gibi)
    let uniqueValues;
    const sampleValue = data.find(row => row[config.field])?.[config.field];
    if (Array.isArray(sampleValue)) {
      const flatSet = new Set();
      data.forEach(row => {
        const val = row[config.field];
        if (Array.isArray(val)) val.forEach(v => { if (v) flatSet.add(v); });
      });
      uniqueValues = [...flatSet];
    } else {
      uniqueValues = [...new Set(data.map(row => row[config.field]))].filter(Boolean);
    }

    return {
      id: config.id || config.field,
      field: config.field,
      label: t ? t(config.label) : config.label,
      value: '',
      filterType: config.filterType || 'exact',
      options: uniqueValues
        .map(value => ({
          value: value,
          label: config.formatValue
            ? config.formatValue(value)
            : t && config.i18nPath
              ? t(`${config.i18nPath}.${value}`)
              : value,
        }))
        .sort((a, b) => {
          // Ensure both labels are strings before comparing
          const labelA = String(a.label || '');
          const labelB = String(b.label || '');
          return labelA.localeCompare(labelB);
        }),
    };
  });
};
